import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../redux/hooks';
import { logout } from '../redux/slices/authSlice';
import AmbientBackground from '../components/AmbientBackground';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleBackToSignIn = async () => {
    await dispatch(logout());
    navigate('/signin', { replace: true });
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 text-white">
      <AmbientBackground />
      <div className="relative w-full max-w-md rounded-[2rem] border border-white/10 bg-white/10 p-8 text-center shadow-glow backdrop-blur-2xl">
        <div className="text-sm uppercase tracking-[0.3em] text-brand-200">Access denied</div>
        <h1 className="mt-4 text-2xl font-semibold">You do not have access</h1>
        <p className="mt-3 text-sm leading-6 text-white/70">
          Your account is signed in, but it is not listed in the access environment configuration.
        </p>
        <button
          type="button"
          onClick={() => void handleBackToSignIn()}
          className="mt-6 rounded-2xl bg-brand-500 px-5 py-3 text-sm font-semibold text-white transition hover:bg-brand-400"
        >
          Back to sign in
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
